import { render, staticRenderFns } from "./MediumEditor.vue?vue&type=template&id=20e81368"
import script from "./MediumEditor.vue?vue&type=script&lang=js"
export * from "./MediumEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports